import {AbstractPointSnapStrategy} from './AbstractPointSnapStrategy';
import {PointSnapStrategyType} from './PointSnapStrategyType';
import type {PointSnapRequest, PointSnapResult} from './PointSnapTypes';

/**
 * 尺在网格线显示时捕捉策略。
 */
export class DynamicRulerPointSnapStrategy extends AbstractPointSnapStrategy {
    /** 策略类型。 */
    public readonly strategyType: PointSnapStrategyType = PointSnapStrategyType.DynamicRuler;

    /**
     * 执行尺在网格线显示时捕捉。
     * @param request 点捕捉请求参数。
     * @returns 点捕捉结果。
     */
    public resolve(request: PointSnapRequest): PointSnapResult | null {
        void request;
        // 尚未实现，返回 null 表示无捕捉命中。
        return null;
    }
}
